import * as React from 'react'
import { tw } from 'utils/classnames'
import { Link } from '@repo/web-ui/components/link'

export function StyledLink({ className, href, ...rest }: React.ComponentProps<typeof Link>) {
  return (
    <Link
      {...rest}
      href={href as string}
      className={tw(
        'rounded-[6px] border border-transparent px-[10px] py-[6px]',
        'hover:border-gray-800 hover:bg-gray-900 hover:text-gray-500',
        'active:text-service-white-white active:border-violet-500 active:bg-violet-500',
        className,
      )}
    />
  )
}
